'use client';

import { Fragment } from 'react';

import {
  DefaultList,
  RemovableItem,
  RemovableListContainer,
} from './RemovableList.parts';
import { RemovableListProps } from './RemovableList.types';

const RemovableList = ({ list, onEmptyItemClick }: RemovableListProps) => {
  const hasItem = list && list.length > 0;

  if (!hasItem) return <DefaultList onClick={onEmptyItemClick} />;

  return (
    <RemovableListContainer>
      {list.map((item, index) => (
        <Fragment key={index}>
          <RemovableItem
            text={item.text}
            onClick={item.onClick}
            onRemove={item.onRemove}
          />
        </Fragment>
      ))}
    </RemovableListContainer>
  );
};

export default RemovableList;
